const projectName = "EApp";
const state = {
  titleChain: [projectName]
};

const getters = {};

const actions = {
  setTitle({ state, commit }, { chain = [], index = 1 }) {
    let newTitleChain = [
      ...state.titleChain.slice(0, index || state.length),
      ...chain
    ];
    commit("setTitle", newTitleChain);
  }
};

const mutations = {
  setTitle(state, titleChain) {
    state.titleChain = titleChain;
    let title = [...state.titleChain].reverse().join(" - ") || projectName;
    document.querySelector("head>title").text = title;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
